import { getGuestGenderByTitle, isGuestAlreadyInArray } from '@utils/helpers';
import { Guest } from 'shared-types/Basket';
import type { ExistingGuest } from 'voyager';

const toExistingGuest = (guest: Guest): ExistingGuest => ({
  id: String(guest.externalSpaId || guest.id || `${guest.firstName}-${guest.lastName}`),
  name: `${guest.firstName} ${guest.lastName}`,
  title: guest.title || '',
  firstName: guest.firstName,
  lastName: guest.lastName,
  gender: guest.gender || getGuestGenderByTitle(guest.title) || '',
  externalSpaId: guest.externalSpaId,
  guestId: guest.id,
  loggedInUser: guest.loggedInUser,
});

export const buildExistingGuests = (
  basketGuests: Guest[],
  loggedInGuest: Guest | null | undefined
): ExistingGuest[] => {
  const existingGuests: ExistingGuest[] = basketGuests.map(toExistingGuest);

  if (
    loggedInGuest?.firstName &&
    loggedInGuest?.lastName &&
    !isGuestAlreadyInArray(basketGuests, loggedInGuest)
  ) {
    existingGuests.unshift(
      toExistingGuest({
        ...loggedInGuest,
        loggedInUser:
          loggedInGuest.loggedInUser ?? (loggedInGuest.id ? { id: loggedInGuest.id } : undefined),
      })
    );
  }

  return existingGuests;
};
